import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { activeDeactiveCategoryAPI, activeDeactiveRoleAPI, addCategoryAPI, addRoleAPI, deleteCategoryAPI, deleteRoleAPI, getAllCategoryAPI, getAllPagesAPI, getAllParentCategoryAPI, getAllRolesAPI, getDocumentsTypeAPI, getTableColumnNames, updateCategoryAPI, updatePagePermissionAPI, updateRoleAPI } from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import { t } from "i18next";



// Fetch Category Table Column Names
export const fetchCategoryTableColumnNames = createAsyncThunk(
  "categories/fetchTableColumnNames",
  async (category, thunkAPI) => {
    try {
      const response = await getTableColumnNames(category); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);

// Thunk to fetch all categories
export const fetchAllCategories = createAsyncThunk(
  "categories/fetchAll",
  async (logs, thunkAPI) => {
    try {
      const response = await getAllCategoryAPI(logs); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);

export const fetchParentCategories = createAsyncThunk(
  "categories/fetchParentCategories",
  async (categories, thunkAPI) => {
    try {
      const response = await getAllParentCategoryAPI(categories); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);

// Add Category data
export const createCategory = createAsyncThunk("categories/add", async (category, thunkAPI) => {  
  try {
    const response = await addCategoryAPI(category);
    toast.success(t(response.message));
    return response;
  } catch (error) {
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

// Update Category data
export const updateCategories = createAsyncThunk("categories/update", async (category, thunkAPI) => {

  try {
    const response = await updateCategoryAPI(category);
    toast.success(t(response.message));
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

// Delete Category data
export const deleteCategory = createAsyncThunk("categories/delete", async (category, thunkAPI) => {
  try {
    const response = await deleteCategoryAPI(category);
    toast.success(t(response.message));
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

// Active deactive Category
export const activateDeactivateCategories = createAsyncThunk("categories/active", async (category, thunkAPI) => {
  try {
    const response = await activeDeactiveCategoryAPI(category);
    toast.success(t(response.message));
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});


export const getDocumentsType = createAsyncThunk(
  "categories/getDocumentsType",
  async (thunkAPI) => {
    try {
      const response = await getDocumentsTypeAPI(); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);